import {
  Pipe,
  PipeTransform,
  Injector,
  NgModule,
  ModuleWithProviders
} from '@angular/core';

import { OTranslateService } from '../services';


export class OTranslatePipe implements PipeTransform {

  protected translateService: OTranslateService;

  constructor( protected injector: Injector ) {
    this.translateService = this.injector.get(OTranslateService);
  }

  transform(text: string): string {
    if (this.translateService) {
      return this.translateService.get(text);
    }
    return text;
  }

static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'oTranslate',
  pure: false
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
];
}


export class OTranslateModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: OTranslateModule,
      providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OTranslatePipe],
  imports: [],
  exports: [OTranslatePipe]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
